module.exports = __webpack_public_path__ + "static/media/select.abc5ca29.svg";